module.exports = __webpack_public_path__ + "img/KHU_icon.3cbd91e2.png";